// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"dL-z","carouselContainer":"eL-z"};